<template>
  <div>
    <SearchPanel v-bind:dashId="dashId" :published="published" :entry="entry"></SearchPanel>
    <div class="mt-1"></div>
    <Dashboard v-bind:user="user" :dashId="dashId" :published="published"></Dashboard>
  </div>

</template>

<script>
import Dashboard from "./Dashboard";
import SearchPanel from "./SearchPanel";
import axios from "axios";
import {mapActions} from "vuex";

export default {
  name: "Home",
  props: ['user', "dashId", "entryType", "applicationContext"],
  components: {
    Dashboard,
    SearchPanel,
  },
  data: function () {
    return {
      published: null,
      entry : null,
    }
  },
  created: function () {
    if (this.entryType === "gallery_entry") {
      this.published = true
      this.retrieveGalleryInfo()
    }
    console.debug("Setting application context to: "+this.applicationContext)
    this.setApplicationContext(this.applicationContext)
  },
  methods: {

  ...mapActions([
      'setApplicationContext'
    ]),


    retrieveGalleryInfo() {
      let me = this
      axios
          .get(encodeURI(this.$store.state.apiRootPath + 'gallery_entry/' + this.dashId))
          .then(function (response) {
            me.entry = response.data.entry
          })
    }
  }
}
</script>

<style scoped>

a:hover {
  text-decoration: none;
}

</style>